import React from "react";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// local
import OrganisationContainer from "./OrganisationContainer";
import Filters from "./Filters";

const Admin = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container>
        <Grid item xs={12} md={12} xl={12}>
          <MDBox py={3} pl={1}>
            <Filters />
          </MDBox>
        </Grid>

        <Grid item xs={12} md={12} xl={12}>
          <MDBox py={3} pr={1}>
            <OrganisationContainer />
          </MDBox>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default Admin;
